import * as React from "react";

interface Props {
  width?: number;
  height?: number;
}

class Spinner extends React.PureComponent<Props> {
  render() {
    return (
      <div
        className="spinner"
        style={{
          width: this.props.width ? this.props.width + "px" : "50px",
          height: this.props.height ? this.props.height + "px" : "50px",
        }}
      />
    );
  }
}

export default Spinner;
